import { toast, ToastContainer } from "react-toastify";
import Label from "../components/Label";
import { signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import auth from "../firebase/auth";
import axiosJwt from "../utils/axiosJwt";

export default function AddReviewForm() {
  const navigate = useNavigate();

  const handleSubmitReview = (event) => {
    event.preventDefault();

    const form = event.target,
      formdata = Object.fromEntries(new FormData(form));

    axiosJwt
      .post(`${process.env.REACT_APP_SERVER_ENDPOINT}/reviews`, formdata)
      .then(({ data }) => {
        if (data.insertedId) {
          toast.success("Added Review Successfully");

          form.reset();
        } else {
          toast.error("Couldn't Add Review");
        }
      })
      .catch((error) => {
        if ([401, 403].includes(error?.response?.status)) {
          signOut(auth);

          localStorage.removeItem("token");

          navigate("/login");
        }

        toast.error("Couldn't Add Review");
      });
  };

  return (
    <form
      onSubmit={handleSubmitReview}
      class="card flex-shrink-0 w-full max-w-sm shadow-2xl bg-base-100"
    >
      <ToastContainer />

      <div class="card-body">
        <div class="form-control">
          <Label label="Name" />

          <input
            type="text"
            name="name"
            placeholder="name"
            class="input input-bordered"
            required
          />
        </div>

        <div class="form-control">
          <Label label="Institution" />

          <input
            type="text"
            name="institution"
            placeholder="institution"
            class="input input-bordered"
            required
          />
        </div>

        <div class="form-control">
          <Label label="Rating" />

          <input
            type="number"
            name="rating"
            min={1}
            max={5}
            defaultValue={5}
            class="input input-bordered"
            required
          />
        </div>

        <div class="form-control">
          <Label label="Review" />

          <textarea
            type="text"
            name="review"
            placeholder="Review..."
            class="textarea input-bordered h-24"
            required
          />
        </div>

        <div class="form-control mt-6">
          <button type="submit" class="btn btn-primary">
            Submit Review
          </button>
        </div>
      </div>
    </form>
  );
}
